module.exports = __webpack_public_path__ + "static/media/room-12.0056b57f.jpg";